'use strict'
const _ = require('lodash')
const {createPageManager} = require('../../helpers/pageManager')
const {migrateToNewMenuComponent} = require('../../helpers/oldMenuToNewMenuHelper')
const {
    migrateStylableComponentsByCompType
} = require('../../helpers/stylableMigration/migrateStylableComponentsByCompType')
const {NAMESPACE_MAPPING} = require('@wix/document-services-json-schemas/dist/constants.json')
const {
    migrateMenuLayout,
    migrateSubmenuLayout,
    clearAllTemporaryProperties,
    stylableMigrationConfig,
    migrateMenuDirections
} = require('@wix/component-migration/migrateStylableHorizontalMenuToNewMenu')

const {migrateMegaMenuContainerItem} = require('./megaMenuContainerItem')
const {migrateStructuredMegaMenuSubmenu} = require('./structuredMegaMenuSubmenu')

const migrateStylesAndLayoutPanelForEachBreakpoint = (oldComponent, pageManager) => {
    const styleKeys = pageManager.data.getItem(NAMESPACE_MAPPING.style, oldComponent.styleId)
    const cleanedPropsKey = oldComponent.propertyQuery.replace('#', '')
    const componentProps = pageManager.data.getItem(NAMESPACE_MAPPING.props, cleanedPropsKey)

    styleKeys.values.forEach(styleKey => {
        const cleanedStyleKey = styleKey.replace('#', '')
        const currentBreakpoint = pageManager.data.getItem(NAMESPACE_MAPPING.style, cleanedStyleKey)
        //Different breakoint than the Desktop/root
        if (currentBreakpoint.type === 'VariantRelation') {
            const variantKey = currentBreakpoint.to.replace('#', '')
            const variantStyle = pageManager.data.getItem(NAMESPACE_MAPPING.style, variantKey)
            const variantStyleProperties = variantStyle.style.properties
            const variantStylePropertiesOverride = variantStyle.style.propertiesOverride
            const variantStylePropertiesSource = variantStyle.style.propertiesSource
            migrateMenuLayout(variantStyle, componentProps)
            migrateSubmenuLayout(variantStyle, componentProps)
            migrateMegaMenuContainerItem(pageManager, oldComponent, variantStyle, currentBreakpoint.variants)
            clearAllTemporaryProperties({
                styleProperties: variantStyleProperties,
                propertiesOverride: variantStylePropertiesOverride,
                propertiesSource: variantStylePropertiesSource
            })
        }
        //Desktop/root breakpoint
        if (currentBreakpoint.type === 'ComponentStyle') {
            const componentStyle = currentBreakpoint
            const componentStyleProperties = componentStyle.style.properties
            const componentStylePropertiesOverride = componentStyle.style.propertiesOverride
            const componentStylePropertiesSource = componentStyle.style.propertiesSource
            const cleanDataQuery = oldComponent.dataQuery.replace('#', '')
            const dataItem = pageManager.data.getItem(NAMESPACE_MAPPING.data, cleanDataQuery)
            migrateMenuDirections(dataItem, componentStyle)
            migrateMenuLayout(componentStyle, componentProps)
            migrateSubmenuLayout(componentStyle, componentProps)
            migrateMegaMenuContainerItem(pageManager, oldComponent, componentStyle)
            clearAllTemporaryProperties({
                styleProperties: componentStyleProperties,
                propertiesOverride: componentStylePropertiesOverride,
                propertiesSource: componentStylePropertiesSource
            })
        }

        migrateStructuredMegaMenuSubmenu(pageManager, oldComponent)
    })
}

const STYLABLE_HORIZONTAL_MENU = 'wixui.StylableHorizontalMenu'

const migrateStylableHorizontalMenuToNonStylable = ({
    structure,
    data,
    uniqueIdGenerator,
    clientSpecMap,
    magicObject
}) => {
    migrateStylableComponentsByCompType({
        structure,
        data,
        uniqueIdGenerator,
        clientSpecMap,
        compType: STYLABLE_HORIZONTAL_MENU,
        magicObject,
        ...stylableMigrationConfig,
        postStyleMigrationCallback: (migratedStyle, originalStyle) => {
            stylableMigrationConfig.postStyleMigrationCallback(migratedStyle, originalStyle)
            migratedStyle.properties['horizontal-item-icon-display'] = 'none'
            migratedStyle.propertiesSource['horizontal-item-icon-display'] = 'value'
            return migratedStyle
        }
    })
}

function migratePage({pageManager, structure, data, uniqueIdGenerator, clientSpecMap, magicObject}) {
    migrateStylableHorizontalMenuToNonStylable({structure, data, uniqueIdGenerator, clientSpecMap, magicObject})
    const {desktopComponents} = pageManager.structure.getAllComponentsBasedOnType(STYLABLE_HORIZONTAL_MENU)

    _.forEach(desktopComponents, component => {
        migrateStylesAndLayoutPanelForEachBreakpoint(component, pageManager)
        migrateToNewMenuComponent(component, pageManager)
    })
}

module.exports = {
    name: 'migrateStylableHorizontalMenuToNewMenu',
    version: 0,
    experimentalVersions: [
        {version: 1, experiment: 'dm_migrateStylableHorizontalMenuToNewMenu'},
        {version: 2, experiment: 'dm_migrateBlocksWidgetsToNonStylable'}
    ],
    migrateStylableHorizontalMenuToNonStylable,
    exec(pageJson, _pageIdsArray, magicObject) {
        if (!magicObject.isExperimentOpen('dm_migrateStylableHorizontalMenuToNewMenu')) {
            return
        }
        const {clientSpecMap} = magicObject
        const {uniqueIdGenerator} = magicObject.dataFixerUtils
        const pageManager = createPageManager(pageJson, uniqueIdGenerator)
        const {data, structure} = pageJson

        migratePage({pageManager, structure, data, uniqueIdGenerator, clientSpecMap, magicObject})
    }
}
